import { MapTo, withComponentMappingContext } from '@adobe/aem-react-editable-components';
import { withRoute } from '../RouteHelper/RouteHelper';
import { AppPage } from './Page';

export default MapTo(
    [
        'cob-corp-acquisition/components/page',
        'cob-corp-acquisition/components/xfpage',
        'cob-corp-acquisition/components/creditonebank/page-templates/corporate',
        'cob-corp-acquisition/components/creditonebank/page-templates/about-us',
        'cob-corp-acquisition/components/creditonebank/page-templates/homepage',
        'cob-corp-acquisition/components/creditonebank/page-templates/credit-cards',
        'cob-corp-acquisition/components/creditonebank/page-templates/product-page',
        'cob-corp-acquisition/components/creditonebank/page-templates/article-page',
        'cob-corp-acquisition/components/creditonebank/page-templates/press-release',
        'cob-corp-acquisition/components/creditonebank/page-templates/article-landing',
        'cob-corp-acquisition/components/creditonebank/page-templates/faq',
        'cob-corp-acquisition/components/creditonebank/page-templates/glossary',
    ],
)(
    withComponentMappingContext(withRoute(AppPage)),
);